import { render } from "./TransferModal.vue?vue&type=template&id=5393cc44"
import script from "./TransferModal.vue?vue&type=script&lang=js"
export * from "./TransferModal.vue?vue&type=script&lang=js"

import "./TransferModal.vue?vue&type=style&index=0&id=5393cc44&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__